import { render, staticRenderFns } from "./NeedsDashboard.vue?vue&type=template&id=a151a4c0&"
import script from "./NeedsDashboard.vue?vue&type=script&lang=js&"
export * from "./NeedsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedsDashboard.vue"
export default component.exports